import { useTranslation } from "react-i18next";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import BaseHeader from "@/components/Header/BaseHeader";
import { OBSERVATIONS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Observations";
import ObservationsTable from "@/components/ListTable/ObservationsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { OBSERVATIONS_FILTERS } from "@/entities/observations";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { ListProvider } from "@/modules/list";

const Observations = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:observations")} />
      <AppLayoutPage>
        <ListProvider
          endpoint="observations"
          storageKey={STORAGE_KEYS.OBSERVATIONS}
          hiddenFilters={{ [OBSERVATIONS_FILTERS.CATEGORY]: "defect" }}
          defaultSort={["-risk_level", "state"]}
          withMetadata={["statistics"]}
          withContext
        >
          <WidgetsGrid widgets={OBSERVATIONS_STATISTICS_WIDGETS}>
            <ObservationsTable />
          </WidgetsGrid>
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Observations;
